module.exports = __webpack_public_path__ + "static/media/right_icon2.png";